export default __webpack_public_path__ + "static/media/ts_help2.1278c5df.png";